export const FRICTIONLESS_PAYMENT_PATH = 'apps/subscriptions/payment-update';
